import { DisplayMode } from "../enums/display-mode.enum";
import { useEffect, useState } from 'react';
import { device } from "../services/device-detector.service";

export const useDefineStatusByDisplayMode = (displayMode: DisplayMode) => {
  const [status, setStatus] = useState<boolean>(null);

  useEffect(() => {
		let status: boolean;

		switch (displayMode) {
			case DisplayMode.ENABLE:
				status = true;
				break;
			
			case DisplayMode.DISABLE:
				status = false;
				break;
			
			case DisplayMode.MOBILES_ONLY: {
				if (device.isMobile()) status = true;
					else status = false;
				break;
			}

			case DisplayMode.PC_ONLY: {
				if (device.isDesktop()) status = true;
					else status = false;
				break;
			}
		
			default:
				status = true;
		}

		setStatus(status);
	}, [displayMode]);

  return status;
}